import { Node, useEditor, useNode } from '@craftjs/core'
import React, { CSSProperties, useEffect, useRef } from 'react'
import './AIVideo.scss'
import { useMediaQuery } from '@mui/material'
import { getStyle } from '../../services/HelperService'
import { useAiVideo, useRecipient } from '../../contexts/RecipientContext'
import { useEnvironment } from '../../hooks/useEnvironment'

export const AIVideo = () => {
  const {
    connectors: { connect },
    parent,
    props,
  } = useNode((node) => ({ parent: node.data.parent, props: node.data.props }))
  const { query: { node } } = useEditor()
  const { variables }: any = useRecipient()
  const mobile = useMediaQuery('(max-width:500px)')
  const containerRef = useRef<HTMLDivElement>(null)
  const { aiVideoEnabled } = useAiVideo()
  const { isProd } = useEnvironment()
  const campaignId = props.campaignId

  let parentNode: Node = node(parent).get()
  let style: CSSProperties = { ...getStyle(props.style, props.mobileStyle, parentNode, mobile) }

  let newVars = {
    first_name: variables?.first_name,
    last_name: variables?.last_name,
    year: variables?.auto_year,
    make: variables?.auto_make,
    model: variables?.auto_model,
    book_value: variables?.auto_trade_in_value,
  }

  useEffect(() => {
    if (!aiVideoEnabled) return

    const script = document.createElement('script')
    script.setAttribute('data-api-key', process.env.REACT_APP_AI_VIDEO_API_KEY)
    script.setAttribute('data-campaign-id', campaignId)
    script.src = process.env.REACT_APP_AI_CDN_LINK
    script.async = true
    script.defer = true

    if(isProd) {
      script.setAttribute('data-environment', 'production')
    }

    script.onload = () => {
      if (window.InteractiveAgentWidget && containerRef.current) {
        const widget = new window.InteractiveAgentWidget({
          apiKey: process.env.REACT_APP_AI_VIDEO_API_KEY,
          campaignId,
          container: '#agentContainer',
          width: '100%',
          height: '100%',
          customVars: newVars,
        })
        widget.init()
      }
    }
    document.body.appendChild(script)
    return () => {
      if (containerRef.current) containerRef.current.innerHTML = ''
    }
  }, [])

  return (
    <div ref={(ref) => connect(ref)} style={style} className="ai-video-holder">
      {aiVideoEnabled &&<div id="agentContainer" ref={containerRef} />}
      {!aiVideoEnabled && (
        <div className="error-holder">
          <div className="icon-holder">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="22" fill="#333"></circle>
              <rect x="22" y="12" width="4" height="16" fill="white"></rect>
              <rect x="22" y="30" width="4" height="4" fill="white"></rect>
            </svg>
          </div>
          <p>
          AI Video is unavailable because it has not been enabled for this
          campaign.
          </p>
        </div>
      )}
    </div>
  )
}

AIVideo.craft = {
  displayName: 'AIVideo',
}
